<template>
    <v-content>
      <v-container fluid>
        <h1 class="py-3">
          <v-btn small fab color="secondary" :to="{ path: '/groupinfos' }"><v-icon>reply</v-icon></v-btn>
          <span v-if="groupinfo" class="titleText pl-2">Groupinfo - {{ groupinfo.co_groupcode }}</span>
          <span v-else class="titleText pl-2">Groupinfo</span>
        </h1>
        <v-alert v-if="error" :value="true" type="error">
          {{ error }}
        </v-alert>
        <template v-if="groupinfo">
          <h4>Groupinfo Information</h4>
          Groupinfo Name: <strong>{{ groupinfo.co_groupname }}</strong><br/>
          Groupinfo Description: <strong>{{ groupinfo.co_groupdesc }}</strong><br/>
          <v-divider class="my-3"/>
          <h4 class="pb-2">Assets contained within this group</h4>
          <GenericListTable
            :parentID="this.parentID"
            :title="`Assets`"
            :headers="[
                { text: 'ID', value: 'id' },
                { text: 'Asset Id', value: 'co_assetid' },
                { text: 'Description', value: 'co_description' },
                { text: 'Asset State', value: 'assetstate' },
                { text: 'Asset Note', value: 'assetnote' },
                { text: 'Group code', value: 'co_groupcode' },
                { text: 'Device Name', value: 'devicename' },
                { text: 'Location ID', value: 'co_locationid' },
              ]"
            :url="`/manifest/assetinfo?groupcode=`"
            :apiResponseField="`assetinfolist`"
            :onClickRoute="`AssetSingle`"
            :onClickParams="getOnClickParams"
            :apiQueryParams="this.groupinfo.co_groupcode"
            :editable="false"
            >

          </GenericListTable>
        </template>
        <v-btn depressed @click="getNames()">
          <v-icon right>replay</v-icon>
          <span>Refresh Groupinfo Device Names</span>
        </v-btn>
      </v-container>
    </v-content>
</template>

<script>

import GenericListTable from '@/components/Common/GenericListTable'

export default {
  name: 'GroupinfoSingle',
  components: { GenericListTable },
  props: {
    parentID: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      error: false,
      id: undefined,
      groupinfo: undefined
    }
  },
  beforeMount () {
    this.id = this.$route.params.id
    if (this.id) {
      // Get groupinfo information.
      this.$http.get('/manifest/groupinfo?groupid=' + this.id)
        .then(request => this.buildGroupinfoSingle(request.data))
        .catch(() => this.failedGroupinfoSingle())
    } else {
      this.errorHandler('Groupinfo ID not found.')
    }
  },
  methods: {
    buildGroupinfoSingle (data) {
      this.groupinfo = data
    },
    failedGroupinfoSingle () {
      this.errorHandler('Failed to retrieve groupinfo.')
    },
    errorHandler (error) {
      this.error = error
    },
    failedReconcileNames () {
      this.errorHandler('Failed to request Refresh of Names.')
    },
    getNames () {
      // Reconcile ALL device name 'description and location' - for toplevel Groupinfo
      // Quick and dirty, get confiogured default baseURL and switch out /api for /data
      var dataURL = this.$http.defaults.baseURL.replace('api', 'reconcile')
      this.$http({
        baseURL: dataURL,
        url: '/device/details?groupinfo=' + this.groupinfo.companyname
      })
        .catch(() => this.failedReconcileNames())
    },
    getOnClickParams (item) {
      return {
        id: item.co_assetid
      }
    }
  }
}
</script>

<style>
h1 .titleText {
  vertical-align: middle;
}
</style>
